/**
 * PositSortControls.tsx
 * 
 * Sorting controls component for the Posits listing.
 * Extracted from MyPosits.tsx to improve modularity and reusability.
 */

import React from "react";
import { SortAsc, SortDesc } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PositSortControlsProps {
  sortOrder: "asc" | "desc";
  setSortOrder: (value: "asc" | "desc") => void;
  sortBy: "date" | "title";
  setSortBy: (value: "date" | "title") => void;
}

const PositSortControls: React.FC<PositSortControlsProps> = ({
  sortOrder,
  setSortOrder,
  sortBy,
  setSortBy,
}) => {
  const toggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  return (
    <div className="flex items-center space-x-2">
      <Button
        variant={sortBy === "date" ? "default" : "outline"}
        size="sm"
        className="h-9"
        onClick={() => setSortBy("date")}
      >
        Date
      </Button>
      
      <Button
        variant={sortBy === "title" ? "default" : "outline"}
        size="sm"
        className="h-9"
        onClick={() => setSortBy("title")}
      >
        Title
      </Button>
      
      <Button
        variant="outline"
        size="sm"
        className="h-9 px-2"
        onClick={toggleSortOrder}
        title={sortOrder === "asc" ? "Ascending" : "Descending"}
      >
        {sortOrder === "asc" ? (
          <SortAsc className="h-4 w-4" />
        ) : (
          <SortDesc className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
};

export default PositSortControls; 